import ProjectGrouping from "@/pages/ProjectGrouping"
import CostImporterAdministrator from "@/pages/CostImporterAdministrator.vue"
import CostImporterTransactionMatchingStaff from "@/pages/CostImporterTransactionMatchingStaff.vue"
import AdminRoles from "@/pages/AdminRoles"
import AdminRolePermissions from "@/pages/AdminRolePermissions"
import AdminUsers from "@/pages/AdminUsers"
import AccessDenied from "@/pages/AccessDenied"
import Login from "@/pages/Login"
import JobsReview from "@/pages/JobsReview"
import JobsAuditReport from "@/pages/JobsAuditReport"
import JobsKeywordsReport from "@/pages/JobsKeywordsReport"
import Invoicing from "@/pages/Invoicing"
import CostMover from "@/pages/CostMover"
import ContactList from "@/pages/ContactList"
import LeadsPage from "@/pages/LeadsPage.vue"
import AdminSettings from "@/pages/AdminSettings"
import TestPage from "@/pages/TestPage"
import AdminServicesPage from "@/pages/AdminServicesPage.vue"
import AdminCapacityPage from "@/pages/AdminCapacityPage.vue"
import ReportCapacityWeeklyByServicePage from "@/pages/ReportCapacityWeeklyByServicePage.vue"
import ReportWorkloadPage from "@/pages/ReportWorkloadPage.vue"
import StaffPlanSchedulePage from "@/pages/StaffPlanSchedulePage.vue"
import JobCapacityPage from "@/pages/JobCapacityPage.vue"
import ReportLongTermCapacityPage from "@/pages/ReportLongTermCapacityPage.vue"
import StaffPlanScheduleReviewPage from "@/pages/StaffPlanScheduleReviewPage.vue"
import WIPSetupPage from "@/pages/WIPSetupPage.vue"
import ReportKPIPage from "@/pages/ReportKPIPage.vue"
import ReportServiceScheduleSummaryPage from "@/pages/ReportServiceScheduleSummaryPage.vue"
import ReportPipelinePage from "@/pages/ReportPipelinePage.vue"
import AdminXeroContactSupplierMatchingPage from "@/pages/AdminXeroContactSupplierMatchingPage.vue"
import AdminBackgroundTasks from "@/pages/AdminBackgroundTasks.vue"
import ReportProjectCostVariancePage from "@/pages/ReportProjectCostVariancePage.vue"
import JobsReviewProjectManagers from "@/pages/JobsReviewProjectManagers.vue"
import ReportLeadsPage from "@/pages/ReportLeadsPage.vue"
import ReportChargeRatesPage from "@/pages/ReportChargeRatesPage.vue"
import JobTimePlannerPage from "@/pages/JobTimePlannerPage.vue"
import ReportRawData from "@/pages/ReportRawData.vue"
import AdminKeywords from "@/pages/AdminKeywords.vue"
import ForecastCashPage from "@/pages/ForecastCashPage.vue"

export const menuGroups = ["All Staff", "Project Managers", "Sales", "Business Administration", "Management Reports", "Settings", "Other"]
export const routes = [
    {
        name: "AccessDeniedPage",
        title: "Access Denied",
        path: "/403",
        showInMenu: false,
        menuGroup: "Internal",
        component: AccessDenied,
    },
    {
        name: "LoginPage",
        title: "Login",
        path: "/login",
        showInMenu: false,
        menuGroup: "Internal",
        component: Login,
    },
    {
        name: "Home",
        title: "Home",
        path: "/",
        showInMenu: false,
        icon: "mdi-home",
        menuGroup: "Internal",
        component: JobsReview,
    },
    {
        name: "JobsReviewStaff",
        title: "Jobs Review (Staff)",
        path: "/jobs/review",
        showInMenu: true,
        menuGroup: "All Staff",
        icon: "mdi-account-hard-hat",
        component: JobsReview,
        keywords: "",
    },
    {
        name: "MatchTransactions",
        title: "Match Transactions",
        path: "/costs/import-staff",
        showInMenu: true,
        menuGroup: "All Staff",
        icon: "mdi-compare-horizontal",
        component: CostImporterTransactionMatchingStaff,
    },
    {
        name: "Scheduling",
        title: "Scheduling",
        path: "/staff/scheduling",
        showInMenu: true,
        menuGroup: "All Staff",
        icon: "mdi-clipboard-list",
        component: StaffPlanSchedulePage,
        keywords: "workload planning tasks"
    },
    {
        name: "JobsReviewProjectManagers",
        title: "Jobs Review (Project Managers)",
        path: "/jobs/review-pm",
        showInMenu: true,
        menuGroup: "Project Managers",
        icon: "mdi-account-hard-hat-outline",
        component: JobsReviewProjectManagers,
    },
    {
        name: "Invoicing",
        title: "Invoicing",
        path: "/jobs/invoicing",
        showInMenu: true,
        menuGroup: "Project Managers",
        icon: "mdi-currency-usd",
        component: Invoicing,
    },
    {
        name: "JobForecast",
        title: "Job Forecast",
        path: "/job-forecast",
        showInMenu: true,
        menuGroup: "Project Managers",
        icon: "mdi-human-capacity-decrease",
        component: JobCapacityPage,
    },
    {
        name: "CostMover",
        title: "Cost Mover",
        path: "/costs/move",
        showInMenu: true,
        menuGroup: "Project Managers",
        icon: "mdi-currency-usd",
        component: CostMover,
    },
    {
        name: "ContactList",
        title: "Contact List",
        path: "/clients/contact-list",
        showInMenu: true,
        menuGroup: "Sales",
        icon: "mdi-account-circle",
        component: ContactList,
    },
    {
        name: "Leads",
        title: "Leads",
        path: "/leads",
        showInMenu: true,
        menuGroup: "Sales",
        icon: "mdi-filter-variant",
        component: LeadsPage,
    },
    {
        name: "JobsAuditReport",
        title: "Jobs Audit Report",
        path: "/report/jobs-audit",
        showInMenu: true,
        menuGroup: "Business Administration",
        icon: "mdi-table",
        component: JobsAuditReport,
    },
    {
        name: "BankReconciliation",
        title: "Bank Reconciliation",
        path: "/costs/import-backoffice",
        showInMenu: true,
        menuGroup: "Business Administration",
        icon: "mdi-cash",
        component: CostImporterAdministrator,
    },
    {
        name: "RawReportData",
        title: "Raw Report Data",
        path: "/report/raw-data",
        showInMenu: true,
        menuGroup: "Business Administration",
        icon: "mdi-raw",
        component: ReportRawData,
    },
    {
        name: "WIPSetup",
        title: "WIP Setup",
        path: "/wip-setup",
        showInMenu: true,
        menuGroup: "Business Administration",
        icon: "mdi-progress-clock",
        component: WIPSetupPage,
    },
    {
        name: "XeroContactSupplierMatching",
        title: "Xero Contact to Supplier Matching",
        path: "/supplier-matching",
        showInMenu: true,
        menuGroup: "Business Administration",
        icon: "mdi-compare-horizontal",
        component: AdminXeroContactSupplierMatchingPage,
    },
    {
        name: "KPIProjectFocusSchedule",
        title: "KPI: Project Focus & Schedule",
        path: "/kpi/project-focus-schedule",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-account-group",
        component: ReportKPIPage,
    },
    {
        name: "KPIProjectCostVariance",
        title: "KPI: Project Cost Variance",
        path: "/kpi/project-cost-variance",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-variable",
        component: ReportProjectCostVariancePage,
    },
    {
        name: "KPIChargeRages",
        title: "KPI: Charge Rates",
        path: "/kpi/charge-rates",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-cash-100",
        component: ReportChargeRatesPage,
    },
    {
        name: "ForecastJobs",
        title: "Forecast: Jobs",
        path: "/forecast/jobs",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-chart-bar",
        component: ReportLongTermCapacityPage,
    },
    {
        name: "ForecastStaffPlannedHours",
        title: "Forecast: Staff Planned Hours",
        path: "/forecast/staff-planned-hours",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-pipe",
        component: ReportPipelinePage,
    },
    {
        name: "ForecastSalesPipeline",
        title: "Forecast: Sales Pipeline",
        path: "/forecast/sales-pipeline",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-filter-variant",
        component: ReportLeadsPage,
    },
    {
        name: "ForecastCash",
        title: "Forecast: Cash",
        path: "/forecast/cash",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-cash",
        component: ForecastCashPage,
    },
    {
        name: "ReportJobAnalysis",
        title: "Report: Job Analysis",
        path: "/report/job-analysis",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-google-analytics",
        component: ProjectGrouping,
    },

    {
        name: "ReportWeeklyCapacityByService",
        title: "Report: Weekly Capacity by Service",
        path: "/report/weekly-capacity-service",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-chart-pie-outline",
        component: ReportCapacityWeeklyByServicePage,
    },
    {
        name: "ReportWorkloadPressure",
        title: "Report: Work Pressure",
        path: "/report/workload-pressure",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-account-group",
        component: ReportWorkloadPage,
    },
    {
        name: "ReportKeywords",
        title: "Report: Keywords Report",
        path: "/report/keywords",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-file-word-box",
        component: JobsKeywordsReport,
    },
    {
        name: "ReportServiceSchedule",
        title: "Report: Service Schedule",
        path: "/report/service-schedule",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-room-service",
        component: ReportServiceScheduleSummaryPage,
    },
    {
        name: "ReportWorkloadReview",
        title: "Report: Workload Review",
        path: "/planning/workload-review",
        showInMenu: true,
        menuGroup: "Management Reports",
        icon: "mdi-clipboard-list",
        component: StaffPlanScheduleReviewPage,
    },
    {
        name: "AdminRoles",
        title: "Roles & Permissions",
        path: "/admin/roles",
        showInMenu: true,
        menuGroup: "Settings",
        icon: "mdi-account-cog",
        component: AdminRoles,
    },
    {
        name: "AdminRolePermissions",
        title: "Permissions",
        path: "/admin/role/:id/permissions",
        showInMenu: false,
        menuGroup: "Settings",
        icon: "mdi-account-cog",
        component: AdminRolePermissions,
    },
    {
        name: "Users",
        title: "Users",
        path: "/admin/users",
        showInMenu: true,
        menuGroup: "Settings",
        icon: "mdi-account-cog",
        component: AdminUsers,
    },
    {
        name: "Settings",
        title: "Settings",
        path: "/admin/settings",
        showInMenu: true,
        menuGroup: "Settings",
        icon: "mdi-account-cog",
        component: AdminSettings,
    },
    {
        name: "ServicesSetup",
        title: "Services Setup",
        path: "/admin/services",
        showInMenu: true,
        menuGroup: "Settings",
        icon: "mdi-toolbox-outline",
        component: AdminServicesPage,
    },
    {
        name: "CapacitySetup",
        title: "Capacity Setup",
        path: "/admin/capacity",
        showInMenu: true,
        menuGroup: "Settings",
        icon: "mdi-human-capacity-decrease",
        component: AdminCapacityPage,
    },
    {
        name: "BackgroundTasks",
        title: "Background Tasks",
        path: "/admin/background-tasks",
        showInMenu: true,
        menuGroup: "Settings",
        icon: "mdi-checkbox-marked-circle-auto-outline",
        component: AdminBackgroundTasks,
    },
    {
        name: "Keywords Setup",
        title: "Keywords Setup",
        path: "/admin/keywords",
        showInMenu: true,
        menuGroup: "Settings",
        icon: "mdi-file-word-box",
        component: AdminKeywords,
    },

    {
        name: "Test",
        title: "Test",
        path: "/test",
        showInMenu: false,
        menuGroup: "",
        icon: "",
        component: TestPage,
    },
    {
        name: "Gantt",
        title: "Test",
        path: "/gantt",
        showInMenu: false,
        menuGroup: "",
        icon: "",
        component: JobTimePlannerPage,
    },
]
